"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Interaction mode types.
 * @namespace {object}
 */
// tslint:disable-next-line:no-namespace
var InteractionMode;
(function (InteractionMode) {
    InteractionMode.EDIT = 0; // Default mode, all is editable
    InteractionMode.LIVE = 1; // Live mode
})(InteractionMode = exports.InteractionMode || (exports.InteractionMode = {}));
/**
 * @method isPreviewMode
 * @argument mode The mode to compare, must ve a valid InteractionMode type.
 * @description Utility that returns a boolean indicating if the provided
 * mode is 'preview' mode.
 * @returns boolean
 */
function isPreviewMode(mode) {
    return mode === InteractionMode.LIVE;
}
exports.isPreviewMode = isPreviewMode;
/**
 * @method isLiveMode
 * @argument mode The mode to compare, must ve a valid InteractionMode type.
 * @description Utility that returns a boolean indicating if the provided
 * mode is 'preview' mode.
 * @returns boolean
 */
function isLiveMode(mode) {
    return isPreviewMode(mode);
}
exports.isLiveMode = isLiveMode;
//# sourceMappingURL=interactionModes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/interactionModes.js
// module id = 53
// module chunks = 35783957827783 127651196306611 162898551421021